import { createFileRoute } from '@tanstack/react-router'
import { SubAssemblyInfo } from 'pages/inventoryManagement/SubAssemblyInfo'
import { z } from 'zod'

const subAssemblySearchParams = z.object({
  mode: z.enum(['edit', 'create', 'view']).optional(),
})

export const Route = createFileRoute('/sub-assembly/$subAssemblyID')({
  component: SubAssemblyInfo,
  validateSearch: subAssemblySearchParams,
  staticData: {
    title: 'Sub-Assembly',
    layout: {
      enableScrolling: true,
      enforceMaxWidth: true,
    },
  },
})
